export default (object) => {
    return !!(object && object.constructor && object.call && object.apply);
};
